import React, { FC, useEffect } from 'react';
import './SpinsPage.scss';

import { ItvGenericPage } from '../ItvGenericPage';
import { useUserContext } from '../../../providers/UserProvider';
import { BRANDS } from '../../../components/Itv/types';

export const SpinsPage: FC = () => {
  const { setTheme } = useUserContext();

  useEffect(() => {
    setTheme(BRANDS.SPINS);
  }, []);

  return <ItvGenericPage variant="spins" />;
};
